// 免费及限免方案不消耗用户的付费方案免费下载次数。
export const canUseFreeCaseDownload = (detail) => {
  return !!detail && detail.solutionLevel != null &&
    String(detail.solutionLevel) !== '3' && Number(detail.charges) > 0 &&
    detail.activityFreeStatus !== 'PROCEED'
}



// WEBPACK FOOTER //
// ./src/utils/freeCaseDownload.js